/**
 * Structured diagnostics for membership/API failures (staging only).
 * Logs origin, route, status, failure type, app/SW version for debugging CORS/auth.
 */
const ENV = typeof process !== 'undefined' && process.env && process.env.REACT_APP_ENV;
const isStaging = ENV === 'staging' || (typeof window !== 'undefined' && (window.location.hostname || '').includes('staging'));

function getAppVersion() {
  try {
    return typeof window !== 'undefined' && window.__ARTMO_APP_VERSION;
  } catch (_) { return undefined; }
}

function getSwVersion() {
  try {
    if (typeof navigator !== 'undefined' && navigator.serviceWorker?.controller) return 'active';
    return 'none';
  } catch (_) { return undefined; }
}

function getBrowserInfo() {
  if (typeof navigator === 'undefined') return {};
  const ua = navigator.userAgent || '';
  return {
    isSafari: /Safari/.test(ua) && !/Chrome/.test(ua),
    isIOS: /iPad|iPhone|iPod/.test(ua),
  };
}

export function logMembershipDiagnostics(payload) {
  if (!isStaging) return;
  const info = {
    origin: typeof window !== 'undefined' ? window.location.origin : undefined,
    route: payload.route || 'membership/status',
    status: payload.status,
    statusText: payload.statusText,
    failureType: payload.failureType, // 'network' | 'cors' | '401' | '403' | 'inactive' | 'timeout'
    appVersion: getAppVersion(),
    sw: getSwVersion(),
    ...getBrowserInfo(),
    ts: new Date().toISOString(),
  };
  console.warn('[staging] membership diagnostics', info);
}
